import {Button} from '@mui/material';
import {ButtonProps} from '@mui/material/Button';

import React, {forwardRef} from 'react';

const MuiButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({sx, ...props}, ref) => (
    <Button
      ref={ref}
      variant='contained'
      color='primary'
      disableElevation
      sx={{borderRadius: '21px', textTransform: 'none', ...sx}}
      {...props}
    />
  )
);

export default MuiButton;
